// Itens que regeneram vida e mana enquanto equipados (dados oficiais do Canary, items.xml: healthgain/healthticks/managain/manaticks).
// Como no Global, os anéis com duração gastam o tempo enquanto equipados (World.wearTick). Chave = id do item (ativo e desequipado).
export interface ItemRegen { hp: number; hpTicks: number; mana: number; manaTicks: number }
export const ITEM_REGEN: Record<number, ItemRegen> = {
  3052: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  3089: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  3098: {hp: 6, hpTicks: 6000, mana: 24, manaTicks: 6000},
  3100: {hp: 6, hpTicks: 6000, mana: 24, manaTicks: 6000},
  3549: {hp: 3, hpTicks: 6000, mana: 12, manaTicks: 6000},
  6530: {hp: 3, hpTicks: 6000, mana: 12, manaTicks: 6000},
  6529: {hp: 3, hpTicks: 6000, mana: 12, manaTicks: 6000},
  8081: {hp: 1, hpTicks: 3000, mana: 4, manaTicks: 3000},
  23474: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  23475: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  23476: {hp: 3, hpTicks: 6000, mana: 12, manaTicks: 6000},
  23477: {hp: 3, hpTicks: 6000, mana: 12, manaTicks: 6000},
  23527: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  23531: {hp: 1, hpTicks: 6000, mana: 4, manaTicks: 6000},
  23532: {hp: 1, hpTicks: 6000, mana: 4, manaTicks: 6000},
  23543: {hp: 2, hpTicks: 6000, mana: 8, manaTicks: 6000},
  45643: {hp: 4, hpTicks: 5000, mana: 16, manaTicks: 5000},
};
